<header class="navbar navbar-fixed-top bg-system">
    <div class="navbar-logo-wrapper">
        <a class="navbar-logo-text" href="/" ng-click="mainPage()">
            <img src="img/logo-blue.svg" alt="Hodxpress.com">
             
        </a>
    </div>

    <ul class="nav navbar-nav navbar-left">
        <li class="hidden-xs">
            <a class="navbar-fullscreen toggle-active" href="/satin-al">
                <strong class="p10 fs18">Paketler</strong>
            </a>
        </li>
    </ul>
    <ul class="nav navbar-nav navbar-right intercom">
        <li class="hidden-xs">
            <a href="#" class="navbar-fullscreen fs18 toggle-active" ng-click="intercom()">
                <img src="/img/Destek.png" alt="" width="24px">
            </a>
        </li>
    </ul>
</header>
